import template from './employees_currently_on_leave_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class EmployeesCurrentlyOnLeaveHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EmployeesCurrentlyOnLeaveHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeesCurrentlyOnLeaveHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EmployeesCurrentlyOnLeaveHelp',
	dialog_class: EmployeesCurrentlyOnLeaveHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employees_currently_on_leave_help',
	provider: 'ps'
};
